module.exports = __webpack_public_path__ + "static/media/forefront-sports.0b108c66.webp";